import { render, staticRenderFns } from "./ThgPartnerVehicles.vue?vue&type=template&id=37dbc561&"
import script from "./ThgPartnerVehicles.vue?vue&type=script&lang=ts&"
export * from "./ThgPartnerVehicles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
